<template>
  <base-modal
    title="CREATE NEW FOLDER"
    :id="id"
    :value="value"
    extra-class="modal-sm"
    @shown="clear"
    @input="$emit('input', $event)"
  >
    <form data-vv-scope="add-folder">
      <div class="form-group" :class="{ 'has-error': errors.has('add-folder.name') }">
        <label for="add-folder-name">Folder Name</label>
        <input id="add-folder-name" class="form-control" name="name" type="text" v-validate="'required'" v-model="addFolderName">
        <span v-show="errors.has('add-folder.name')" class="help-block">{{ errors.first('add-folder.name') }}</span>
      </div>
    </form>
    <template #footer>
      <button class="btn green mt-ladda-btn ladda-button add-folder-button" data-style="expand-left" @click.prevent="createFolder(addFolderName)">
        <span class="ladda-label">Add Folder</span>
      </button>
      <button class="btn default" data-dismiss="modal">Cancel</button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions} from 'vuex';

import BaseModal from "../BaseModal";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      id: 'create-folder-modal',
      addFolderName: '',
    }
  },
  methods: {
    ...mapActions({
      createFolderAction: 'CREATE_FOLDER_ACTION',
    }),
    clear() {
      this.addFolderName = '';
      this.$validator.reset();
    },
    createFolder(name) {
      this.$validator.validateAll('add-folder').then((result) => {
        if (result) {
          Ladda.create(document.querySelector('.add-folder-button'));
          this.createFolderAction({name: name});
          $(`#${this.id}`).modal('hide');
        }
      });
    },
  },
  components: {BaseModal},
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// CreateFolderModal.vue?82b7d05c